<template>
    <div class="selected-container single-field" v-if="selected">
        <q-chip
            color="primary"
            text-color="white"
            icon-remove="fa-solid fa-circle-xmark"
            :removable="!disable"
            @remove="onRemove(selected?.id ?? '')"
            :data-qs="`${selected.text}-chip`"
        >
            <div class="ellipsis">
                {{ selected.text }}
                <q-tooltip>{{ selected.text }}</q-tooltip>
            </div>
        </q-chip>
    </div>
</template>

<script setup lang="ts">
import { FacetValue } from "../../facets.model";

defineProps<{
    selected: FacetValue;
    onRemove: (id: string) => void;
    disable?: boolean;
}>();
</script>

<style lang="scss" scoped>
.single-field {
    max-width: 400px;
}
</style>
